import type { UseToastOptions } from "@chakra-ui/react"

// don't import files or modules into this file
const { APP_ENV } = process.env
let env: "development" | "staging" | "production"

if (APP_ENV) {
  env = APP_ENV as "development" | "staging" | "production"
} else {
  const hostname =
    (typeof window !== "undefined" && window?.location?.hostname) || ""
  if (
    hostname.includes("admin-stg.supliful.com") ||
    hostname.includes("supliful-admin-git-develop-supliful.vercel.app") ||
    hostname.includes("-supliful.vercel.app")
  ) {
    env = "staging"
  }
  // Load production data only with the "admin.supliful.com" domain.
  // Vercel offers at least 2 more auto-generated domains to access the production build
  // but strict domain checks should minimize risks of potential false positives that would load
  // production data for a preview build.
  else if (hostname.includes("admin.supliful.com")) {
    env = "production"
  } else {
    env = "development"
  }
}

export const IS_PRODUCTION = env === "production"
export const IS_STAGING = env === "staging"
export const REDIRECT_PATH = "redirect"

export const SENTRY_DSN =
  "https://38d7a2baed3444dcbfbb1ff5b12697e0@o509340.ingest.sentry.io/6100601"
export const FEAT_SENTRY_ENABLED =
  process.env.NEXT_PUBLIC_SENTRY_ENABLED === "true"
export const FEAT_SENTRY_REPLAY_ENABLED =
  process.env.NEXT_PUBLIC_SENTRY_REPLAY_ENABLED === "true"

export const API_HOST =
  process.env.NEXT_PUBLIC_WEB_URL || "http://localhost:5000"
export const API_URL = `${API_HOST}/graphql`

export const WEB_URL = IS_PRODUCTION
  ? "https://admin.supliful.com"
  : IS_STAGING
    ? "https://admin-stg.supliful.com"
    : process.env.NEXT_PUBLIC_WEB_URL || "http://localhost:3003"

export const SESSION_TOKEN = "supliful.admin.token"

// Same Polotno license as web — without it the canvas renders a watermark.
export const POLOTNO_API_KEY = process.env.NEXT_PUBLIC_POLOTNO_API_KEY || ""

export const TIKTOK_ADMIN_SERVICE_ACCOUNT_EMAIL =
  process.env.NEXT_PUBLIC_TIKTOK_ADMIN_SERVICE_ACCOUNT_EMAIL ||
  "tiktok@supliful.com"

export const FBA_ADMIN_SERVICE_ACCOUNT_EMAIL =
  process.env.NEXT_PUBLIC_FBA_ADMIN_SERVICE_ACCOUNT_EMAIL || "fba@supliful.com"

export const SANITY_STUDIO_PROJECT_ID =
  process.env.NEXT_PUBLIC_SANITY_STUDIO_PROJECT_ID || ""
export const SANITY_STUDIO_DATASET =
  process.env.NEXT_PUBLIC_SANITY_STUDIO_DATASET || ""

export const defaultChakraToastOptions: UseToastOptions = {
  duration: 10000,
  position: "bottom-left",
  isClosable: true,
}
